export const DIRECTION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
}